import { render, staticRenderFns } from "./VSelectForm.vue?vue&type=template&id=1507fa78"
import script from "./VSelectForm.vue?vue&type=script&lang=js"
export * from "./VSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports